import { useStaticQuery } from 'gatsby';
const getRandom = (array, count) => {
  return array.sort(() => .5 - Math.random()).slice(0, count);
};
export const useRandomBrandHeaderImages = function (count, type, lowestBrandRating) {
  if (count === void 0) {
    count = 1;
  }
  if (type === void 0) {
    type = 'all';
  }
  if (lowestBrandRating === void 0) {
    lowestBrandRating = 1;
  }
  let brandsValid = false;
  let randomBrands = [];
  let brands = useStaticQuery(query).allDirectusBrands.nodes;
  if (type !== 'all') {
    brands = brands.filter(_ref => {
      let {
        brand
      } = _ref;
      return brand.type.type === type;
    });
  }
  if (lowestBrandRating > 1) {
    brands = brands.filter(_ref2 => {
      let {
        brand
      } = _ref2;
      return brand.brand_rating >= lowestBrandRating;
    });
  }
  while (!brandsValid) {
    const validity = [];
    randomBrands = getRandom(brands, count);
    randomBrands.forEach(_ref3 => {
      let {
        brand
      } = _ref3;
      validity.push(brand.header_images.length !== 0);
    });
    brandsValid = !validity.includes(false);
  }
  return randomBrands;
};
const query = "2259990820";